import { useTranslation } from "react-i18next";

import Layout from "@components/layout/Layout";
import SubscriberSyncUploadTable from "@components/table/SubscriberSyncUploadTable";

const CustomerSyncIndex: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <Layout
      permissions={["BulkUploadSubscriberSync"]}
      breadcrumb={[
        { label: t("common.home"), href: "/polestar" },
        { label: t("topnav.subscribers"), href: "/polestar/subscribers" },
        { label: t("topnav.customer_data_synchronisation") },
      ]}
      title={t("subscriber_sync_upload.title.index")}
    >
      <SubscriberSyncUploadTable />
    </Layout>
  );
};

export default CustomerSyncIndex;
